import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = [
    {
        q: "Como entrar no servidor?",
        a: "Baixe o FiveM no site oficial fivem.net, abra e cole o IP que está na seção Conectar deste site. Depois é só liga o motor e correr.",
    },
    {
        q: "Precisa de whitelist?",
        a: "Não. O servidor é aberto, mas exige leitura das regras. Quem não respeita o código de rua, encontra o ban hammer.",
    },
    {
        q: "Posso usar mods próprios?",
        a: "Mods visuais (ENB, gráficos) são permitidos. Mods que tragam vantagem (trainers, menus) = ban permanente sem retorno.",
    },
    {
        q: "Tem VIP / loja?",
        a: "Em breve. Pretendemos lançar um sistema de apoiadores com cosméticos e veículos exclusivos. Sem pay-to-win, prometido.",
    },
    {
        q: "Quais são os requisitos pra jogar?",
        a: "GTA V original (Steam / Epic / Rockstar) atualizado + FiveM instalado + conexão estável. Configurações mínimas seguem as do GTA V.",
    },
    {
        q: "Como reportar bug ou jogador tóxico?",
        a: "Abre ticket no Discord ou usa o /report in-game. A staff responde em até 24h. Toxicidade é punida na hora.",
    },
];

export default function Faq() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="relative py-24 md:py-40 bg-[#0a0a0a]"
        >
            <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12">
                <div className="lg:col-span-4">
                    <div className="flex items-center gap-3 mb-4">
                        <span className="h-px w-12 bg-neon-yellow" />
                        <span className="font-mono text-xs uppercase tracking-[0.3em] text-neon-yellow">
                            ▸ Tira a dúvida
                        </span>
                    </div>
                    <h2 className="font-heading text-5xl md:text-7xl uppercase tracking-tighter leading-none mb-6">
                        FAQ<br />
                        <span className="text-stroke">do submundo</span>
                    </h2>
                    <p className="text-white/60 text-base">
                        Antes de pegar a estrada, dá uma olhada nas perguntas
                        mais frequentes da galera.
                    </p>
                </div>

                <div className="lg:col-span-8">
                    <Accordion type="single" collapsible className="space-y-3">
                        {FAQ.map((item, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="bg-[#141414] border border-white/10 data-[state=open]:border-neon-yellow px-5 md:px-7 rounded-none"
                            >
                                <AccordionTrigger className="font-heading text-xl md:text-2xl uppercase tracking-tight text-left hover:no-underline hover:text-neon-yellow py-5">
                                    <span className="flex items-center gap-4">
                                        <span className="font-mono text-xs text-neon-yellow">
                                            0{i + 1}
                                        </span>
                                        {item.q}
                                    </span>
                                </AccordionTrigger>
                                <AccordionContent className="text-white/70 text-base leading-relaxed pb-5 pl-8">
                                    {item.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
